import React from 'react';
import PropTypes from 'prop-types';
import kebabCase from 'lodash/kebabCase';
import padStart from 'lodash/padStart';

import PaymentMethodModel from 'models/payment-method';
import UserModel from 'models/user';

const propTypes = {
  paymentMethod: PropTypes.instanceOf(PaymentMethodModel).isRequired,
  user: PropTypes.instanceOf(UserModel).isRequired,
  deleteMethod: PropTypes.func.isRequired,
  editMethod: PropTypes.func.isRequired,
};

const CreditCard = ({ paymentMethod, user, deleteMethod, editMethod }) => (
  <div>
    <div className="card-body text-weight-light">
      <div className="vertical-padding-bottom">
        <strong>{paymentMethod.label}</strong>
      </div>
      <div>
        <div>{user.name}</div>
        <div>
          <span className={`iconified iconified-space-right iconified-${kebabCase(paymentMethod.cardType)}`} />
          &bull;&bull;&bull;&bull;&nbsp;
          {paymentMethod.lastFourDigits}
        </div>
        <div>{`Expires ${padStart(paymentMethod.expirationMonth, 2, '0')}/${paymentMethod.expirationYear}`}</div>
        <div>{paymentMethod.postalCode}</div>
      </div>
    </div>
    <div className="card-footer text-center">
      <div className="row">
        <div className="col-xs-6 clickable padding-left-2x padding-right-0 text-left" onClick={editMethod}>
          <span className="edit text-weight-medium clickable">EDIT</span>
        </div>
        <div className="col-xs-6 clickable" onClick={deleteMethod}>
          <span className="delete text-weight-medium clickable">DELETE</span>
        </div>
      </div>
    </div>
  </div>
);

CreditCard.propTypes = propTypes;

export default CreditCard;
